wbApp.controller('AttendanceLogCtrl', ['$scope', '$modal', '$window', '$translate', '$filter', '$q', 'messageBoxSvc', 'rfidCardsSvc', 'securitySvc', 'groupSvc', 'gridSortSvc', 'tenantSettingSvc',
function ($scope, $modal, $window, $translate, $filter, $q, messageBoxSvc, rfidCardsSvc, securitySvc, groupSvc, gridSortSvc, tenantSettingSvc) {

    $scope.groups = groupSvc.getAllAsync();
    $scope.rawAttendanceLog = [];
    $scope.attendanceLog = [];
    $scope.hasAttendanceWithoutGroup = false;

    $scope.customFilter = { groups: [] };

    function preFilter() {
        $q.all([$scope.rawAttendanceLog.$promise, $scope.groups.$promise]).then(function () {

            $scope.hasAttendanceWithoutGroup = !!_.find($scope.rawAttendanceLog,
                function (o) {
                    return (!o.groups || !o.groups.length) && !o.isDeleted;
                }
            );

            var groupIDs = _.values($scope.customFilter.groups);
            $scope.attendanceLog.length = 0;
            $scope.attendanceLog.push.apply($scope.attendanceLog,
                _.filter($scope.rawAttendanceLog, function (o) {
                    if (groupIDs.length > 0) {
                        return _.intersection(o.groups, groupIDs).length > 0;
                    }
                    return true;
                })
            );
        });
    }

    $scope.$watch('customFilter', function (newValue, oldValue) {
        preFilter();
    }, true);

    var inUpdateRole = securitySvc.isInRole('RfidCardLog.Update');
    var inInsertRole = securitySvc.isInRole('RfidCardLog.Insert');
    var inDeleteRole = securitySvc.isInRole('RfidCardLog.Delete');
    var inSupportRole = securitySvc.isInRole('Support');


    $scope.rowAddDisabled = !inInsertRole;

    $scope.fromDate = moment().startOf('month').toDate();
    $scope.toDate = moment().endOf('month').toDate();

    function resetOriginalState(row) {

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_RESET_TO_DEFAULTS',
            message: 'TXT_TEXT_CONFIRM_RESET_TO_DEFAULTS',
            buttons: [{
                text: 'TXT_BTN_NO',
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    rfidCardsSvc.reset(row, $scope.rawAttendanceLog, function () {
                        preFilter();
                    }, null);
                }
            }]
        });
    }

    $scope.gridSettings = {
        name: 'attendanceLog',
        columns: [
            { dataField: 'userID', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            {
                dataField: 'eventTime',
                caption: $translate.instant('TXT_LBL_EVENT_TIME'),
                sortOrder: 'desc',
                dataType: 'date',
                format: {
                    skeleton: 'yMEdHms'
                },
                width: '160px'
            },
            {
                dataField: 'validationErrorMessage',
                caption: "",
                dataType: 'string',
                allowFiltering: false,
                allowHeaderFiltering: false,
                encodeHtml: false,
                calculateCellValue: function (rowData) {
                    return $filter('errorIndicator')(rowData.validationErrorMessage);
                },
                width: '25px'
            },
            {
                dataField: 'description',
                caption: $translate.instant('TXT_NOTE'),
                dataType: 'string',
                allowFiltering: false,
                allowHeaderFiltering: false,
                encodeHtml: false,
                calculateCellValue: function (rowData) {
                    return $filter('noteIndicator')(rowData.description);
                },
                width: '25px'
            },

            {
                dataField: 'userIDType',
                caption: $translate.instant('TXT_LBL_TYPE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('rfidCardUserType')(rowData.userIDType);
                },
                width: '80px'
            },
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '180px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'operatorFullName', caption: $translate.instant('TXT_LBL_USER'), dataType: 'string', 
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'operatorFullName') }
            },
            {
                dataField: 'deviceSerialNumber',
                caption: $translate.instant('TXT_LBL_DEVICE_SERIAL_NUMBER'),
                dataType: 'string',
                width: '90px',
                alignment: 'right'

            },
            //{ dataField: 'operatorAddress', caption: $translate.instant('TXT_LBL_ADDRESS'), dataType: 'string' },
            //{ dataField: 'operatorEmail', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px' },
            //{
            //    dataField: 'operatorPhone',
            //    caption: $translate.instant('TXT_LBL_PHONE'),
            //    dataType: 'string',
            //    calculateCellValue: function (rowData) {
            //        return $filter('phone')(rowData.operatorPhone);
            //    },
            //    width: '130px'
            //},
            {
                dataField: 'groups',
                caption: $translate.instant('TXT_MENU_GROUPS'),
                dataType: 'string',
                encodeHtml: false,
                allowFiltering: false,
                allowHeaderFiltering: false,
                calculateCellValue: function (rowData) {
                    return $filter('groupsColors')(rowData.groups);
                },
                width: '70px'
            },
            {
                dataField: 'uploadedAt',
                caption: $translate.instant('TXT_LBL_UPLOADED_AT'),
                dataType: 'date',
                format: { datetime: 'short' },
                width: '110px',
                visible: inInsertRole
            },            
            { dataField: 'isDeleted', caption: $translate.instant('TXT_VAL_DELETED'), dataType: 'boolean', width: 0 }
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.isDeleted) {
                    e.rowElement.addClass('text-muted');
                } else {
                    if (inUpdateRole && data.overriden) {
                        e.rowElement.addClass('text-danger');
                    }
                    if (!inUpdateRole && data.overridenWithDescription) {
                        e.rowElement.addClass('text-danger');
                    }
                }
            }
        },
        shouldShowAdd: function () { return inInsertRole; },
        shouldShowEdit: function (row) {
            return ((!row.isDeleted || !String.prototype.isNullOrWhitespace(row.description)) &&
                    (inUpdateRole || !String.prototype.isNullOrWhitespace(row.description)));
        },
        shouldDisableEdit: function (row) {
            return ((row.isDeleted && String.prototype.isNullOrWhitespace(row.description)) ||
                    (!inUpdateRole && String.prototype.isNullOrWhitespace(row.description)));
        },
        shouldShowDelete: function (row) {
            return (!row.isDeleted && inDeleteRole);
        },
        //shouldDisableDelete: function (row) {
        //    return (row.isDeleted || !inDeleteRole);
        //},
        disableDeleteConfirmation: true,
        customCommands: [{
            text: $translate.instant('TXT_LBL_RESET_TO_DEFAULT'),
            isVisible: function (row) { return row.rfidCardLogOverrideID && inUpdateRole; },
            callback: function (row) {
                resetOriginalState(row);
            }
        }, {
            text: $translate.instant('TXT_LBL_MPSV_ATTENDANCE_REPORT'),
            callback: function (row) {
                showMPSVReportParamsDialog(false);
            },
            isVisible: function (row) { return tenantSettingSvc.settings.childrenGroupSupport; }

        }, {
            text: $translate.instant('TXT_LBL_MPSV_NURSERY_ATTENDANCE_REPORT'),
            callback: function (row) {
                showMPSVReportParamsDialog(true);
            },
            isVisible: function (row) { return tenantSettingSvc.settings.smallNurserySupport; }

        }, {
            text: tenantSettingSvc.settings.rfidAttendanceEUSupport
                ? $translate.instant('TXT_LBL_MPSV_STUDENT_ATTENDANCE_REPORT')
                : $translate.instant('TXT_LBL_STUDENT_ATTENDANCE_REPORT'),
            callback: function (row) {
                showMPSVStudentReportParamsDialog(false);
            },
            isVisible: function (row) { return tenantSettingSvc.settings.childrenGroupSupport ||
                    tenantSettingSvc.settings.smallNurserySupport;
            }
        }, {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_TITLE_EFS_IMPORT'),
            callback: function (row) {
                showEfsReportImportDetail();
            },
            isVisible: function (row) {
                return inSupportRole;
            }
        }, {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_TITLE_DELETE_ALL_IN_RANGE'),
            callback: function (row) {
                showAttendanceLogSupportDetail('delete-all-in-range');
            },
            isVisible: function (row) {
                return inSupportRole;
            }
        }, {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_TITLE_DELETE_USER_IN_RANGE'),
            callback: function (row) {
                showAttendanceLogSupportDetail('delete-user-in-range');
            },
            isVisible: function (row) {
                return inSupportRole;
            }
        }, {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_TITLE_REPLACE_USER_IN_RANGE'),
            callback: function (row) {
                showAttendanceLogSupportDetail('replace-user-in-range');
            },
            isVisible: function (row) {
                return inSupportRole;
            }
        }, {
            text: "(" + $translate.instant('TXT_LBL_SUPPORT') + ") " + $translate.instant('TXT_TITLE_SHIFT_TIME_IN_RANGE'),
            callback: function (row) {
                showAttendanceLogSupportDetail('shift-time-in-range');
            },
            isVisible: function (row) {
                return inSupportRole;
            }
        }]
    }

    $scope.$on('refreshData', function (e, data) {
        refreshData($scope.fromDate, $scope.toDate);
    });

    function refreshData(fromDate, toDate) {
        var mfromDate = moment(fromDate);
        var mtoDate = moment(toDate);

        if (mfromDate.isValid() && mtoDate.isValid() && mfromDate.isBefore(mtoDate)) {
            $scope.rawAttendanceLog = rfidCardsSvc.getAllLogsAsync(fromDate, toDate);
        } else {
            $scope.rawAttendanceLog = [];
        }
        preFilter();
    }

    refreshData($scope.fromDate, $scope.toDate);

    $scope.onFromDateChange = function (fromDate) {
        if (fromDate) {
            refreshData(fromDate, $scope.toDate);
        }
    }

    $scope.onToDateChange = function (toDate) {
        if (toDate) {
            refreshData($scope.fromDate, toDate);
        }
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.collection = $scope.rawAttendanceLog;
            detailDialogPromise.$scope.onSave = function () {
                preFilter();
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = rfidCardsSvc.createNew();
            detailDialogPromise.$scope.collection = $scope.rawAttendanceLog;
            detailDialogPromise.$scope.onSave = function () {
                preFilter();
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        deleteConfirmationPromise.$promise.then(function () {
            deleteConfirmationPromise.$scope.model = { description: "" }
            deleteConfirmationPromise.$scope.onDetailSave = function (model) {
                var dataToDelete = angular.copy(data);
                dataToDelete.description = model.description;
                rfidCardsSvc.remove(dataToDelete, $scope.rawAttendanceLog, function () {
                    preFilter();
                });
            }
            deleteConfirmationPromise.show();
        });
    }

    function showMPSVReportParamsDialog(isNursery) {
        mpsvDialogPromise.$promise.then(function () {
            mpsvDialogPromise.$scope.fromDate = $scope.fromDate;
            mpsvDialogPromise.$scope.toDate = $scope.toDate;
            mpsvDialogPromise.$scope.isNursery = isNursery;
            mpsvDialogPromise.$scope.reportGenerated = function (data) {
                $("#dataDownloadIFrame").remove();
                $("body").append("<iframe id='dataDownloadIFrame' src='/Api/RfidCard/Download?fileName=" + data.fileName + "' style='height: 0px;' ></iframe>");
            }
            mpsvDialogPromise.show();
        });
    }

    function showEfsReportImportDetail()
    {
        efsReportImportDetailPromise.$promise.then(function () {
            efsReportImportDetailPromise.show();
        });
    }

    function showAttendanceLogSupportDetail(operationMode)
    {
        attendanceLogSupportDetailPromise.$promise.then(function () {
            attendanceLogSupportDetailPromise.$scope.operationMode = operationMode;
            attendanceLogSupportDetailPromise.$scope.onSave = function () {
                refreshData($scope.fromDate, $scope.toDate);
            }
            attendanceLogSupportDetailPromise.show();
        });
    }
    

    function showMPSVStudentReportParamsDialog() {
        mpsvStudentDialogPromise.$promise.then(function () {
            mpsvStudentDialogPromise.$scope.fromDate = $scope.fromDate;
            mpsvStudentDialogPromise.$scope.toDate = $scope.toDate;
            mpsvStudentDialogPromise.$scope.rfidAttendanceEUSupport = tenantSettingSvc.settings.rfidAttendanceEUSupport;
            mpsvStudentDialogPromise.$scope.reportGenerated = function (fromDate, toDate, students, projectName, projectRegistrationNumber, recipientName) {

                var rr = _.reduce(students, function (result, value, key) {
                    (result[value.deviceSerialNumber] || (result[value.deviceSerialNumber] = [])).push(value.studentID);
                    return result;
                }, {});

                var rrr = _.map(rr, function (value, key) {
                    return {d: key, s: value}
                });

                var shortened = angular.toJson(rrr);

                if (tenantSettingSvc.settings.rfidAttendanceEUSupport) {
                    $window.open(
                        '/Admin/Report/MPSVAttendanceByStudent' +
                        '?StartDate=' + fromDate.toJSON() +
                        '&EndDate=' + toDate.toJSON() +
                        '&projectName=' + encodeURI(projectName) +
                        '&projectRegistrationNumber=' + encodeURI(projectRegistrationNumber) +
                        '&recipientName=' + encodeURI(recipientName) +
                        '&students=' + encodeURI(shortened),
                        '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
                } else {
                    $window.open(
                        '/Admin/Report/AttendanceByStudent' +
                        '?StartDate=' + fromDate.toJSON() +
                        '&EndDate=' + toDate.toJSON() +
                        '&name=' + encodeURI(projectName) +
                        '&providerName=' + encodeURI(recipientName) +
                        '&students=' + encodeURI(shortened),
                        '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
                }
            }

            mpsvStudentDialogPromise.show();
        });
    }

    $scope.downloadBtnClick = function () {
        driverDownloadDetailPromise.$promise.then(function () {
            driverDownloadDetailPromise.show();
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/attendance-log-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var mpsvDialogPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/attendance-log-mpsv-attendance-report.html',
        show: false,
        scope: $scope.$new()
    });

    var mpsvStudentDialogPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/attendance-log-mpsv-student-attendance-report.html',
        show: false,
        scope: $scope.$new()
    });

    var deleteConfirmationPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/attendance-log-delete-confirmation.html',
        show: false,
        scope: $scope.$new()
    });

    var efsReportImportDetailPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/efs-report-import-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var attendanceLogSupportDetailPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/attendance-log-support-detaill.html',
        show: false,
        scope: $scope.$new()
    });

    var driverDownloadDetailPromise = $modal({
        templateUrl: 'rfid-cards/attendance-log/driver-download-detaill.html',
        show: false,
        scope: $scope.$new()
    });
}]);
